const PRECHAT_SRC = 'https://snippets.freshchat.com/js/fc-pre-chat-form-v2.js'
const WIDGET_SRC = '//fw-cdn.com/11515865/4173454.js'

const PRECHAT_TEMPLATE = {
  heading: 'Chat with us',
  mainbgColor: '#6453ff',
  maintxColor: '#fff',
  SubmitLabel: 'Start Chat',
  textBanner:
    'Before we start, please share your contact details so we can follow up.',
  fields: {
    0: {
      fieldId: 'firstName',
      label: 'First name',
      type: 'text',
      required: 'yes',
      error: 'Please enter a valid first name',
    },
    1: {
      fieldId: 'lastName',
      label: 'Last name',
      type: 'text',
      required: 'yes',
      error: 'Please enter a valid last name',
    },
    2: {
      fieldId: 'email',
      label: 'Email',
      type: 'email',
      required: 'yes',
      error: 'Please enter a valid email',
    },
    3: {
      fieldId: 'cf_company_name',
      label: 'Company name',
      type: 'text',
      required: 'no',
      error: 'Please enter a valid company name',
    },
  },
}

let initPromise = null
let pendingIdentify = null
let userCreatedHandlerAttached = false

function loadScript(src, attrs) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve()
      return
    }
    const script = document.createElement('script')
    script.src = src
    script.async = true
    if (attrs) {
      Object.entries(attrs).forEach(([key, value]) =>
        script.setAttribute(key, value),
      )
    }
    script.onload = () => resolve()
    script.onerror = (error) => reject(error)
    document.body.appendChild(script)
  })
}

function readInputValue(selectors) {
  for (const selector of selectors) {
    const element = document.querySelector(selector)
    if (element && element.value) return element.value.trim()
  }
  return undefined
}

function setAppSource() {
  if (window.fcWidget?.user?.update) {
    window.fcWidget.user.update({
      meta: {
        cf_app_source: 'reg',
      },
    })
  }
}

function initPrechat() {
  if (
    window.fcPreChatform &&
    typeof window.fcPreChatform.fcWidgetInit === 'function'
  ) {
    window.fcPreChatform.fcWidgetInit(window.prechatTemplate)
  }

  // Set app source when widget loads
  setAppSource()
}

function attachUserCreatedHandler() {
  if (
    userCreatedHandlerAttached ||
    !window.fcWidget ||
    typeof window.fcWidget.on !== 'function'
  ) {
    return
  }

  window.fcWidget.on('user:created', () => {
    const firstName = readInputValue([
      '#firstName',
      'input#firstName',
      'input[name="firstName"]',
    ])
    const lastName = readInputValue([
      '#lastName',
      'input#lastName',
      'input[name="lastName"]',
    ])
    const email = readInputValue([
      '#email',
      'input#email',
      'input[name="email"]',
    ])
    const company = readInputValue([
      '#cf_company_name',
      'input#cf_company_name',
      'input[name="cf_company_name"]',
    ])

    const payload = {}
    if (firstName) payload.firstName = firstName
    if (lastName) payload.lastName = lastName
    if (email) payload.email = email

    const meta = {}
    if (company) meta.cf_company_name = company
    // Always set app source to identify where user came from
    meta.cf_app_source = 'reg'
    if (Object.keys(meta).length > 0) payload.meta = meta

    if (Object.keys(payload).length > 0 && window.fcWidget?.user?.update) {
      window.fcWidget.user.update(payload)
    }
  })

  userCreatedHandlerAttached = true
}

function applyIdentify(data) {
  const fc = window.fcWidget
  if (!fc) {
    pendingIdentify = data
    return
  }

  const externalId = data && data.externalId
  const email = data && data.email
  const firstName = data && data.firstName
  const lastName = data && data.lastName
  const properties = data && data.properties

  if (externalId && typeof fc.setExternalId === 'function') {
    fc.setExternalId(externalId)
  }

  if (fc.user && typeof fc.user.update === 'function') {
    const payload = {}
    if (email) payload.email = email
    if (firstName) payload.firstName = firstName
    if (lastName) payload.lastName = lastName
    if (properties && Object.keys(properties).length > 0) {
      payload.meta = properties
    }
    if (Object.keys(payload).length > 0) {
      fc.user.update(payload)
    }
  } else if (fc.user) {
    if (email && typeof fc.user.setEmail === 'function') fc.user.setEmail(email)
    if (firstName && typeof fc.user.setFirstName === 'function') {
      fc.user.setFirstName(firstName)
    }
    if (lastName && typeof fc.user.setLastName === 'function') {
      fc.user.setLastName(lastName)
    }
    if (properties && typeof fc.user.setProperties === 'function') {
      fc.user.setProperties(properties)
    }
  }
}

function initFreshchat() {
  if (initPromise) return initPromise

  window.prechatTemplate = PRECHAT_TEMPLATE
  window.fcWidgetMessengerConfig = {
    siteId: 'reg-finsei-com',
    config: {
      showFAQOnOpen: false,
      eagerLoad: true,
      cssNames: {
        widget: 'custom_fc_frame',
        expanded: 'custom_fc_expanded',
      },
    },
    onLoad: function () {
      initPrechat()
    },
  }

  window.fcSettings = {
    onInit: function () {
      // Set app source on init
      setAppSource()

      if (window.fcWidget && typeof window.fcWidget.on === 'function') {
        window.fcWidget.on('widget:loaded', function () {
          initPrechat()
        })
      } else {
        initPrechat()
      }
      attachUserCreatedHandler()
      if (pendingIdentify) {
        const data = pendingIdentify
        pendingIdentify = null
        applyIdentify(data)
      }
    },
  }

  initPromise = loadScript(PRECHAT_SRC)
    .then(() => loadScript(WIDGET_SRC, { chat: 'true' }))
    .catch(() => {})

  return initPromise
}

function identifyUser(data) {
  initFreshchat()
  applyIdentify(data)
}

/**
 * Same API as Vue 2 Vue.$freshchat — for Pinia/modules outside components.
 * Replaces: Vue.$freshchat = api
 */
export const freshchat = {
  init: initFreshchat,
  identify: identifyUser,
}

export default {
  install(app) {
    if (typeof window === 'undefined') return

    // Vue 2: Vue.prototype.$freshchat = api
    app.config.globalProperties.$freshchat = freshchat

    initFreshchat()
  },
}
